import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import injectSheet from 'react-jss';
import propTypes from 'prop-types';

import * as revealActions from '../../../actions/revealActions';

let styles = {
  root: {
    zIndex: 1500
  },
  paper: {
    display: 'block',
    borderRadius: '4px',
    boxShadow: '0 0px 6px 0px rgba(0, 0, 0, .20)'
  }
};

class Reveal extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.onBackdropClick = this.onBackdropClick.bind(this);
  }

  static propTypes = {
    classes: propTypes.object.isRequired,
    openedReveal: propTypes.any,
    children: propTypes.any,
    id: propTypes.string,
    className: propTypes.string,
    maxWidth: propTypes.any,
    revealActions: propTypes.object,
    footer: propTypes.any
  };

  onBackdropClick() {
    this.props.revealActions.setOpenReveal();
  }

  render() {
    const { openedReveal, children, id, className, maxWidth, footer, classes } = this.props;

    let isOpen = openedReveal && openedReveal === id ? true : false;
    let maxWidthValue = maxWidth ? maxWidth : 'sm';

    return (
      <Dialog
        open={isOpen}
        className="dialog"
        onBackdropClick={this.onBackdropClick}
        classes={classes}
        maxWidth={maxWidthValue}
      >
        <DialogContent className={className}>{children}</DialogContent>
        {footer}
      </Dialog>
    );
  }
}

function mapStateToProps(state) {
  return {
    openedReveal: state.reveal.openedReveal
  };
}

function mapDispatchToProps(dispatch) {
  return {
    revealActions: bindActionCreators(revealActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(injectSheet(styles)(Reveal));
